import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { PeriodDateJson } from "../../../models/dtos/chart/PeriodDateJson";
import { PeriodDate, PeriodDateTypeString } from "../../../models/interfaces/chart/PeriodDate";
import GlobalSerivce from "../../../services/base/GlobalSerivce";
import AuthenticatedComponent from "../../base/AuthenticatedComponent/AuthenticatedComponent";
import Nav from "../../shared/nav-menu/Nav";
import './DatepickerLayout.scss';
export default class DatepickerLayout extends AuthenticatedComponent<{
    showFooter: boolean, headerAction: boolean, afterSelect: any, afterInit?: PeriodDate, title: string
        , onHandleActiveDatePicker: any, isActiveDatePicker: boolean
}, {

    staticDate: PeriodDateJson[];
}> {

    globalService: GlobalSerivce;
    constructor(props: any) {
        super(props);
        this.globalService = new GlobalSerivce();
        this.state = { staticDate: [] };
    }

    componentDidMount = () => {
        let self = this;
        self.getData();
    }

    reciveData = (periodDate: PeriodDateJson) => {
        this.props.onHandleActiveDatePicker(false);
        this.props.afterSelect(periodDate);
    }

    getData = () => {
        let self = this;
        self.globalService.getPeriodDate().then(function (response) {
            self.setState({ staticDate: response });

            if (self.props.afterInit !== null) {
                self.reciveData(response.filter(date => date.periodDate === PeriodDate.CurrentMonth)[0]);
            }
        });

    }

    render(): ReactNode {
        ;

        let { headerAction, title, onHandleActiveDatePicker, isActiveDatePicker } = this.props;
        let headerContent;
        let content;
        if (!isActiveDatePicker) {
            headerContent = (<>
                <span className="mdi mdi-calendar mdi-24px" onClick={() => this.props.onHandleActiveDatePicker(true)}></span>
            </>);
            content = (<></>);
        }
        else {
            headerContent = (<>
                <span className="mdi mdi-close" onClick={() => this.props.onHandleActiveDatePicker(false)}></span>
            </>);
            content = (<>
                <div style={{ textAlign: "right" }}>
                    <div className="title">
                        <label>بازه زمانی</label>
                    </div>
                    <div className="botoon-section">
                        {this.state.staticDate.map((date, key) => {

                            return <button key={key} className="date-picker-bottom btn-radius margin font-style" onClick={() => this.reciveData(date)}>
                                {PeriodDateTypeString(date.periodDate)}
                            </button>
                        })}
                    </div>
                </div>
            </>);
        }

        let headerActionContent;
        if (!headerAction) {
            headerActionContent = (<>
                <NavLink to={"/Exams"} className="pd-top-8">
                    <label className="mdi mdi-arrow-left f-28" ></label>
                </NavLink>
            </>);
        }
        else {
            headerActionContent = (
                <>
                    <div className="main-menu">
                        <NavLink to={"/UserProfile"}>
                            <label className="mdi mdi-account-circle f-28" ></label>
                        </NavLink>
                        <NavLink to={"/Rewards"}>
                            <label className="mdi mdi-gift f-28"></label>
                        </NavLink>
                    </div>
                </>
            );
        }

        return (<>

            <div className="page datepicker-layout-area" dir="ltr">
                <div className="main">
                    <div className="header px-12">
                        <div className="title-area">
                            {headerContent}

                            <label className=" mr-1">{title}</label>
                        </div>
                        {headerActionContent}
                    </div>

                    {content}

                    <div className={"content-menu padding-18-lr " + (isActiveDatePicker ? "open-DatePicker" : "close-DatePicker")} >
                        {this.props.children}
                        {
                            this.props.showFooter ? (<div className="footer">
                                <Nav />
                            </div>) : (<></>)
                        }

                    </div >
                </div >
            </div >
        </>);
    }
}